import { Component, inject } from '@angular/core';
import { StaffService } from './shared/services/v5/staff';
import { AuthService } from '@schoolbelle/api/auth';
import { LazyChunkRecoveryService } from '@sbe/services';
import { LocationService } from '@schoolbelle/common/location';
import { EMPTY, catchError, filter, switchMap } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'sbe-staff';

  authV4 = inject(AuthService);
  staffV5 = inject(StaffService);

  constructor(
    private location: LocationService, // this should be here! don't touch!
    private lazyChunkRecovery: LazyChunkRecoveryService, // this should be here! don't touch!
  ) {}

  ngOnInit() {
    /**
     * Tree B(@sbe/api/auth) AuthStore에 v5 staff scope 토큰을 proactive 주입.
     * app.module에 등록된 HTTP interceptor가 Tree B AuthStore를 참조하므로 이 호출이 필수.
     * staff-login.service도 upgradeAsStaff를 호출하지만 그쪽은 Tree A(SMS HttpBackend 전용).
     * 서버에 _upgrade_as_staff POST가 2회 나가는 건 dual-store 구조상 불가피.
     */
    this.authV4.user
      .pipe(
        filter(Boolean),
        switchMap(() =>
          this.staffV5.upgradeAsStaff(this.authV4.tokenInfo?.refresh_token).pipe(
            catchError((err: unknown) => {
              console.error('[AppComponent] v5 upgradeAsStaff 실패', err);
              return EMPTY;
            }),
          ),
        ),
      )
      .subscribe();
  }
}
